import React from "react";
const FieldErrorComponent = props => {
  const errorAmount = props.errors.length;

  // React hook form validation
  if (props.errors.message) {
    return /*#__PURE__*/React.createElement("p", {
      id: props.id ? props.id + "-error" : null,
      className: "form__field-error"
    }, props.errors.message);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, (props.errors || []).map((item, i) => {
    return /*#__PURE__*/React.createElement("p", {
      key: i,
      id: i === 0 && props.id ? props.id + "-error" : null,
      className: `form__field-error ${errorAmount > 1 ? "form__field-error--stacked" : ""}`
    }, item);
  }));
};
export default FieldErrorComponent;